export default __webpack_public_path__ + "static/media/test.ab09b7c9.jpg";